import {Porthole} from '../modules/Porthole';

class CrossDomainTransport {
    constructor(frameUrl, frameId, callbacks) {
        this._portal = null;
        this._callbacks = callbacks;

        (frameUrl && typeof frameUrl === 'string') && (frameId && typeof frameId === 'string')
            ? this._portal = new Porthole.WindowProxy(frameUrl, frameId)
            : this._portal = new Porthole.WindowProxy(frameUrl);

        if (!this._portal) return;

        this._portal.addEventListener(this.onMessage.bind(this));

        return {
            setCallback: this._setCallback.bind(this),
            post: this._post.bind(this),
            destroy: this._destroy.bind(this),
            callbacks: () => this._callbacks
        }
    }

    onMessage({data = {}}) {
        const {cmd, value} = data;
        if (this._callbacks[cmd] != null) {
            this._callbacks[cmd](value)
        }
        else {
            console.log(`Callback for '${cmd}' is not defined.`);
        }
    }

    _setCallback(name, fn) {
        ((name, fn) => {
            this._callbacks[name] = fn;
        })(name, fn)
    }

    _post(fnName, value) {
        ((fnName, value) => {
            const msg = {cmd: fnName, value};
            this._portal.post(msg)
        })(fnName, value)
    }

    _destroy() {
        (() => {
            Porthole.WindowProxyDispatcher.stop();
            this._portal.removeEventListener(this.onMessage);
            this._callbacks = null;
            this._portal = null;
        })()
    }
}

export {CrossDomainTransport};
